"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _browser = require("../../utils/browser");
var _getTheoplayerURLBase = _interopRequireDefault(require("../utils/getTheoplayerURLBase"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
// This defines the THEOplayer version
var version = '6.8.0';
var location = (0, _browser.getLocation)();
var theoplayerConfig = {
  version: version,
  // Required on S3 for service workers
  libraryLocation: (0, _getTheoplayerURLBase["default"])(location.protocol, version),
  initialRendition: 'default',
  mutedAutoplay: 'all',
  persistVolume: true,
  retainPlaybackRateOnSourceChange: true,
  cast: {
    strategy: 'disabled'
  },
  // Default license to fall back on
  licenseUrl: 'https://static.hudl.com/theoplayer/License'
};
var _default = exports["default"] = theoplayerConfig;